import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {TestOrderStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {getNavigationURL} from 'nav/sidepanel/listing/SearchURLs';
import {Filter, FilterKey, Operator, SortKey} from 'search/SearchConstants';

import {InaccessibleInfoGraphQL} from '../../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';
import {TestOrderListingGraphQL} from '../../../../graphql-fragments/sample_tests/__generated/TestOrderListingGraphQL';

export type BasicTestOrder = Pick<TestOrderListingGraphQL, '__typename' | 'id' | 'name'>;

export function getTestOrdersSearchUrl(
  testOrders: Array<BasicTestOrder | InaccessibleInfoGraphQL>,
  studyId?: string,
  statusIsOneOf?: Array<TestOrderStatus>
): string {
  const testOrderIds = new Set(
    testOrders.map((testOrder) => (isInaccessible(testOrder) ? testOrder.invalidId : testOrder.id))
  );
  const filters: Array<Filter> = [
    {
      key: FilterKey.TYPES,
      operator: Operator.IS_ONE_OF,
      value: [ModelTypeConstants.TEST_ORDER],
    },
  ];
  if (testOrderIds.size > 0) {
    filters.push({
      key: FilterKey.API_IDS,
      operator: Operator.IS_ONE_OF,
      value: [...testOrderIds],
    });
  }
  if (studyId != null) {
    filters.push({
      key: FilterKey.IN_STUDY,
      operator: Operator.IS,
      value: [studyId],
    });
  }
  if (statusIsOneOf != null) {
    filters.push({
      key: FilterKey.TEST_STATUS,
      operator: Operator.IS_ONE_OF,
      value: statusIsOneOf,
    });
  }
  return getNavigationURL(
    '/search',
    {
      offset: 0,
      limit: 25,
      sorts: [{key: SortKey.SORT_MODIFIED_AT_KEY, reverse: true}],
      filters,
      query: '',
    },
    filters.map((_) => null)
  );
}

export function getTestOrdersByContainerIdsSearchUrl(
  containerIds: Array<string>,
  statusIsOneOf?: Array<TestOrderStatus>
): string {
  assert(containerIds.length > 0, 'Unexpectly no container ids provided');

  const filters: Array<Filter> = [
    {
      key: FilterKey.TYPES,
      operator: Operator.IS_ONE_OF,
      value: [ModelTypeConstants.TEST_ORDER],
    },
    {
      key: FilterKey.SAMPLE_CONTAINER,
      operator: Operator.IS_ONE_OF,
      value: [...containerIds],
    },
  ];

  if (statusIsOneOf != null) {
    filters.push({
      key: FilterKey.TEST_STATUS,
      operator: Operator.IS_ONE_OF,
      value: statusIsOneOf,
    });
  }
  return getNavigationURL(
    '/search',
    {
      offset: 0,
      limit: 25,
      sorts: [{key: SortKey.SORT_MODIFIED_AT_KEY, reverse: true}],
      filters,
      query: '',
    },
    filters.map((_) => null)
  );
}
